export const getParticipantAvatarAbbreviation = (displayName?: string | null) => {
  if (!displayName) {
    return ''
  }

  const name = displayName.split(' ')
  if (name.length > 1) {
    return `${name[0].charAt(0).toUpperCase()}${name[1].charAt(0).toUpperCase()}`
  }
  return displayName.charAt(0).toUpperCase()
}
